import * as React from 'react';
import { PopoverOptions, usePopover, PopoverContext } from './PopoverLogic';

/*
  Richard comment:
  99% of this is just from floating ui example
  some of it is overkill, but it's easier to just copy and use in our app
*/

export function VoxelPopover({
  children,
  modal = true,
  placement = 'bottom-start',
  enableArrow = true,
  ...restOptions
}: {
  children: React.ReactNode;
} & PopoverOptions) {
  // This can accept any props as options, e.g. `placement`,
  // or other positioning options.
  const popover = usePopover({ modal, placement, enableArrow, ...restOptions });
  return <PopoverContext.Provider value={popover} >{children}</PopoverContext.Provider>;
}
